import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationHistoryService } from '../../services/navigation-history.service';

@Component({
  selector: 'app-back-button',
  standalone: true,
  templateUrl: './back-button.component.html',
  styleUrl: './back-button.component.scss'
})
export class BackButtonComponent {
  private readonly router = inject(Router);
  private readonly navigationHistory = inject(NavigationHistoryService);

  get visible(): boolean {
    return this.navigationHistory.isBackButtonVisible();
  }

  goBack(): void {
    this.router.navigateByUrl(this.navigationHistory.getReturnUrl());
  }
}
